/* @jsx h */
import { defineComponent, h, type Ref } from "vue";
import { useRouter } from "vue-router";
import { LemmonSwitcher, useLocalization } from "@lemmonhq/uikit";

export const TablesViewSwitcher = defineComponent<{
  currentView: Ref<string>;
  isReservationMode?: boolean;
}>({
  name: "TablesViewSwitcher",
  props: ["currentView", "isReservationMode"],
  setup(props) {
    const { t } = useLocalization();
    const router = useRouter();
    return () => (
      <LemmonSwitcher
        value={props.currentView.value}
        onChange={(val) => {
          if (!val) return;
          if (val === "list" && props.isReservationMode) {
            router.push("/app/manager/reservations");
            return;
          }
          localStorage.setItem("tables_default_view", String(val));
          props.currentView.value = String(val);
        }}
        iconOnlyOnMobile
        className="w-full sm:w-auto !h-[30px] sm:!h-[36px]"
        buttonClassName="gap-1 px-3 text-[11px] font-medium tracking-wide"
        iconClassName="text-[15px]"
        indicatorClassName="top-[2px] bottom-[2px]"
        options={[
          {
            value: "floor_plan",
            icon: "map",
            label: "Map",
            mobileLabel: t("tables.floor_plan.floor_plans"),
          },
          {
            value: "list",
            icon: "menu",
            label: "List",
            mobileLabel: t("tables.floor_plan.list"),
          },
        ]}
      />
    );
  },
});
